module.exports = __webpack_public_path__ + "static/img/avatar2.e7fba88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar2.png
// module id = d5u0
// module chunks = 2